import { createStyles } from "@mantine/emotion";
import { rem } from "@mantine/core";

export const useStylesIcons = createStyles((theme) => ({
  title: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: theme.spacing.icon.title.marginTop,
  },
  userVerified: {
    width: theme.spacing.icon.userVerified.width,
    height: theme.spacing.icon.userVerified.height,
  },
  copy: {
    marginLeft: theme.spacing.icon.copy.marginLeft,
    marginRight: theme.spacing.icon.copy.marginRight,
    left: theme.spacing.icon.copy.left,
    top: theme.spacing.icon.copy.top,
  },
  width: {
    width: rem(16),
  },
}));
